import React from 'react';
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';

/** Shared inline worker choice; callers retain their own request and save boundaries. */
export function KeepAsExtraSelection({ needed, candidates, selected, onChange, disabled = false, error = '' }: {
  needed: number; candidates: Array<{ jobId: number; name: string; disabled?: boolean }>;
  selected: number[]; onChange: (jobId: number, checked: boolean) => void; disabled?: boolean; error?: string;
}) {
  return <Box sx={{ mt: 1 }}>
    <Typography variant="body2">Select {needed} to Keep As Extra</Typography>
    {candidates.map(person => <FormControlLabel key={person.jobId} label={person.name}
      control={<Checkbox size="small" disabled={disabled || person.disabled} checked={selected.includes(person.jobId)}
        onChange={event => onChange(person.jobId, event.target.checked)} />} />)}
    {error && <Typography role="alert" color="error" variant="body2">{error}</Typography>}
  </Box>;
}

